// extracted by mini-css-extract-plugin
export default {"content":"word-set-pop-up_content__UT5gN","setTitle":"word-set-pop-up_setTitle__JXG2d","about":"word-set-pop-up_about__X2d7H","list":"word-set-pop-up_list__i+Rn+"};